import styled from 'styled-components';

const StyledSlider = styled.div`
  position: relative;
  width: 100%;
  .styled-balloon {
    display: flex;
    position: absolute;
    top: -70px;
    width: 50px;
    left: calc(${props => (props.offset ? props.offset : 0)}% - 25px);
    height: 60px;
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: grab;
    user-select: none;
    &[disabled] {
      cursor: not-allowed;
    }
    &:active:not([disabled]) {
      cursor: grabbing;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }
    .input-overflow {
      position: absolute;
      display: flex;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      max-height: 50px;
      align-items: center;
      justify-content: center;
      font-size: ${props => (!props.isMobile ? 14 : 12)}px;
      font-weight: 500;
      border-radius: 50%;
      overflow: hidden;
      color: #fff;
      input {
        padding: 0;
        position: relative;
        height: 20px;
        text-align: center;
        font-size: ${props => (!props.isMobile ? 14 : 12)}px;
        border-radius: 0;
        color: #555;
      }
    }
  }
`;

export default StyledSlider;
